/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .keyboard[_ngcontent-%COMP%]{max-height:260px;overflow-y:scroll;display:flex;flex-wrap:wrap;justify-content:space-around}[_nghost-%COMP%]   .keyboard[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{width:30px;height:30px;display:flex;justify-content:center;align-items:center;margin:0}[_nghost-%COMP%]   .keyboard[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:hover{border-radius:3px;background-color:#e7eefc}"];
export { styles as styles };
